
import { useToast } from "@/hooks/use-toast";

export const useAuthValidation = () => {
  const { toast } = useToast();

  const validateEmail = (email: string) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email.trim());
  };

  const validateSignUp = (
    email: string, 
    password: string, 
    firstName: string, 
    lastName: string, 
    country: string, 
    acceptedTerms: boolean
  ) => {
    const trimmedEmail = email.trim();
    
    if (!trimmedEmail) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Email is required.",
      });
      return false;
    }

    if (!validateEmail(trimmedEmail)) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Please enter a valid email address.",
      });
      return false;
    }

    if (!password) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Password is required.",
      });
      return false;
    }

    if (!firstName || !lastName || !country) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "All fields marked with * are required.",
      });
      return false;
    }

    if (!acceptedTerms) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "You must accept the terms and conditions to create an account.",
      });
      return false;
    }

    if (password.length < 6) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Password must be at least 6 characters long.",
      });
      return false;
    }

    return true;
  };

  const validateSignIn = (email: string, password: string) => {
    const trimmedEmail = email.trim();
    
    if (!trimmedEmail) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Email is required.",
      });
      return false;
    }

    if (!validateEmail(trimmedEmail)) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Please enter a valid email address.",
      });
      return false;
    }

    if (!password) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Password is required.",
      });
      return false;
    }

    return true;
  };

  const validatePasswordReset = (email: string) => {
    if (!validateEmail(email.trim())) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Please enter a valid email address.",
      });
      return false;
    }
    return true;
  };

  return {
    validateEmail,
    validateSignUp,
    validateSignIn,
    validatePasswordReset,
  };
};
